import React, { FC } from 'react';
import classNames from 'classnames';

import { CurrencyCode } from 'app/api/services/site-configs/types';

import { useTranslation } from 'app/lang';

import { RecordOfEntryErrorType } from '../../../records';
import { ErrorMessage, getErrorMessage, getErrorMessageByType } from './utils/get-error-messages';

import dictionary from './Error.dictionary.json';

import entryStyles from '../EntryComponents.module.scss';

// ---

type ErrorProps = {
  message?: ErrorMessage;
  error?: RecordOfEntryErrorType | null;
  currency?: CurrencyCode;
  className?: string;
  'data-test'?: string;
};

const Error: FC<ErrorProps> = ({ message, error, className, ...props }) => {
  const { t } = useTranslation();
  return (
    <div className={classNames(entryStyles.errorMessage, className)}
         data-test={classNames(props['data-test'], 'error-container')}>
      {
        getErrorMessage(t, message)
        || getErrorMessageByType(t, error, props.currency)
        || t(dictionary.errorMessage)
      }
    </div>
  );
};

export default Error;
